import ApiClient from '@afosto/api/ApiClient';

class Transactions {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a transaction
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Creates a new transaction
   * @returns {Promise}
   */
  createTransaction(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/transactions`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Get transaction information
   *
   * @param {string} secret
   * @param {Object} options - The additional request options
   * @description Returns the details of a transaction
   * @returns {Promise}
   */
  getTransaction(secret, options = {}) {
    return this.apiClient.request({
      url: `/odr/transactions/${secret}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List transactions
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.entityId]
   * @param {string} [query.entityType]
   * @param {Object} options - The additional request options
   * @description Returns list of transactions
   * @returns {Promise}
   */
  listTransactions(query = {}, options = {}) {
    const params = {
      entity_id: query.entityId,
      entity_type: query.entityType,
    };

    return this.apiClient.request({
      url: `/odr/transactions`,
      method: 'get',
      params,
      ...options,
    });
  }
}

export const transactions = new Transactions();

export default Transactions;
